import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Auth from './mixins/Auth';
import RequestHelper from './mixins/RequestHelper';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import {
  /*  DatePicker,
  TimePicker,*/
  Select,
  Option,
  Tag,
  Checkbox,
  DatePicker,
  Notification
  /*ColorPicker,
  Button,
  Switch,
  Radio,
  ,
  Notification,
  Tooltip,
  MessageBox,
  Upload,
  Popover,
  Dialog,
  Tabs,
  TabPane,
  Progress*/
} from 'element-ui';

Vue.config.productionTip = false;

locale.use(lang);
Vue.mixin(Auth);
Vue.mixin(RequestHelper);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(DatePicker);

Vue.prototype.$notify = Notification;

Date.prototype.addDays = function(days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Vue.filter('round', function(value, decimals) {
  if (!value) {
    value = 0;
  }

  if (!decimals) {
    decimals = 0;
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return value;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
